import { useRouter } from "@tanstack/react-router";
import { useUserContext } from "lib/state/UserContextProvider";
import { useEffect } from "react";

/**
 * Mirrors the current user's `enabledFeatures` into the TanStack Router
 * context so `beforeLoad` callbacks on legacy routes can read flags
 * synchronously — primarily used by the showroom unification redirects.
 *
 * Rendered inside both branches of `AppContainer` so it sees the right
 * features on both authed pages (via `UserContextProvider`) and public
 * pages (via the public-page fallback in `useUserContext`).
 *
 * After pushing, `router.invalidate()` re-runs `beforeLoad` so a direct
 * hit on a legacy URL with the flag on bounces as soon as the user /
 * builder has hydrated.
 */
export default function RouterContextSync() {
  const router = useRouter();
  const { enabledFeatures } = useUserContext();

  useEffect(() => {
    router.update({ context: { enabledFeatures } });
    void router.invalidate();
  }, [router, enabledFeatures]);

  return null;
}
